import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="finalize-modal"
export default class extends Controller {
  static targets = ["modal", "confirmationInput", "confirmButton", "inloopCode"]
  static values = { inloopCode: String, finalizeUrl: String }

  connect() {
    // Set the inloop code in the modal text when it becomes available
    if (this.hasInloopCodeTarget) {
      this.inloopCodeTarget.textContent = this.inloopCodeValue
    }
  }

  show() {
    this.modalTarget.classList.remove("hidden")
    
    // Set the inloop code in the modal text if not already set
    if (this.hasInloopCodeTarget && !this.inloopCodeTarget.textContent) {
      this.inloopCodeTarget.textContent = this.inloopCodeValue
    }
    
    this.confirmationInputTarget.focus()
    // Reset input and button state
    this.confirmationInputTarget.value = ""
    this.updateConfirmButton()
  }

  hide() {
    this.modalTarget.classList.add("hidden")
    // Reset input and button state
    this.confirmationInputTarget.value = ""
    this.updateConfirmButton()
  }

  validateInput() {
    this.updateConfirmButton()
  }

  updateConfirmButton() {
    const inputValue = this.confirmationInputTarget.value.trim()
    const isValid = inputValue === this.inloopCodeValue

    if (isValid) {
      this.confirmButtonTarget.disabled = false
      this.confirmButtonTarget.classList.remove("bg-gray-300", "cursor-not-allowed")
      this.confirmButtonTarget.classList.add("bg-red-600", "hover:bg-red-700", "focus:ring-red-500")
    } else {
      this.confirmButtonTarget.disabled = true
      this.confirmButtonTarget.classList.add("bg-gray-300", "cursor-not-allowed")
      this.confirmButtonTarget.classList.remove("bg-red-600", "hover:bg-red-700", "focus:ring-red-500")
    }
  }

  finalize() {
    if (this.confirmationInputTarget.value.trim() === this.inloopCodeValue) {
      // Create and submit form to finalize the inloop
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = this.finalizeUrlValue
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (csrfToken) {
        const csrfInput = document.createElement('input')
        csrfInput.type = 'hidden'
        csrfInput.name = 'authenticity_token'
        csrfInput.value = csrfToken
        form.appendChild(csrfInput)
      }
      
      // Add method override for PATCH
      const methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      methodInput.value = 'PATCH'
      form.appendChild(methodInput)
      
      // Add form to page and submit
      document.body.appendChild(form)
      form.submit()
    }
  }

  // Handle ESC key to close modal
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }

  // Prevent closing when clicking inside modal content
  preventClose(event) {
    event.stopPropagation()
  }
}